/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FindingRemediationPendingRequest,
  FindingStateTransitionHistoryResponse,
  FindingStateTransitionRequest,
  FindingStateTransitionResponse,
} from '../models/index';
import {
    FindingRemediationPendingRequestFromJSON,
    FindingRemediationPendingRequestToJSON,
    FindingStateTransitionHistoryResponseFromJSON,
    FindingStateTransitionHistoryResponseToJSON,
    FindingStateTransitionRequestFromJSON,
    FindingStateTransitionRequestToJSON,
    FindingStateTransitionResponseFromJSON,
    FindingStateTransitionResponseToJSON,
} from '../models/index';

export interface ListMdmFindingStateTransitionsRequest {
    instanceId: string;
    sessionId: string;
}

export interface MarkMdmFindingRemediationPendingRequest {
    instanceId: string;
    sessionId: string;
    findingRemediationPendingRequest?: FindingRemediationPendingRequest;
}

export interface TransitionMdmFindingStateRequest {
    instanceId: string;
    sessionId: string;
    findingStateTransitionRequest: FindingStateTransitionRequest;
}

/**
 * MDMFindingsApi - interface
 * 
 * @export
 * @interface MDMFindingsApiInterface
 */
export interface MDMFindingsApiInterface {
    /**
     * 
     * @summary List finding state transition audit history
     * @param {string} instanceId 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMFindingsApiInterface
     */
    listMdmFindingStateTransitionsRaw(requestParameters: ListMdmFindingStateTransitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindingStateTransitionHistoryResponse>>;

    /**
     * List finding state transition audit history
     */
    listMdmFindingStateTransitions(requestParameters: ListMdmFindingStateTransitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindingStateTransitionHistoryResponse>;

    /**
     * 
     * @summary Mark finding REMEDIATION_PENDING (patch bridge)
     * @param {string} instanceId 
     * @param {string} sessionId 
     * @param {FindingRemediationPendingRequest} [findingRemediationPendingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMFindingsApiInterface
     */
    markMdmFindingRemediationPendingRaw(requestParameters: MarkMdmFindingRemediationPendingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindingStateTransitionResponse>>;

    /**
     * Mark finding REMEDIATION_PENDING (patch bridge)
     */
    markMdmFindingRemediationPending(requestParameters: MarkMdmFindingRemediationPendingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindingStateTransitionResponse>;

    /**
     * 
     * @summary Apply analyst finding state transition
     * @param {string} instanceId 
     * @param {string} sessionId 
     * @param {FindingStateTransitionRequest} findingStateTransitionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMFindingsApiInterface
     */
    transitionMdmFindingStateRaw(requestParameters: TransitionMdmFindingStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindingStateTransitionResponse>>;

    /**
     * Apply analyst finding state transition
     */
    transitionMdmFindingState(requestParameters: TransitionMdmFindingStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindingStateTransitionResponse>;

}

/**
 * 
 */
export class MDMFindingsApi extends runtime.BaseAPI implements MDMFindingsApiInterface {

    /**
     * List finding state transition audit history
     */
    async listMdmFindingStateTransitionsRaw(requestParameters: ListMdmFindingStateTransitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindingStateTransitionHistoryResponse>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling listMdmFindingStateTransitions().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling listMdmFindingStateTransitions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/findings/{instanceId}/state-transitions`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindingStateTransitionHistoryResponseFromJSON(jsonValue));
    }

    /**
     * List finding state transition audit history
     */
    async listMdmFindingStateTransitions(requestParameters: ListMdmFindingStateTransitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindingStateTransitionHistoryResponse> {
        const response = await this.listMdmFindingStateTransitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark finding REMEDIATION_PENDING (patch bridge)
     */
    async markMdmFindingRemediationPendingRaw(requestParameters: MarkMdmFindingRemediationPendingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindingStateTransitionResponse>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling markMdmFindingRemediationPending().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling markMdmFindingRemediationPending().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/findings/{instanceId}/remediation-pending`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindingRemediationPendingRequestToJSON(requestParameters['findingRemediationPendingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindingStateTransitionResponseFromJSON(jsonValue));
    }

    /**
     * Mark finding REMEDIATION_PENDING (patch bridge)
     */
    async markMdmFindingRemediationPending(requestParameters: MarkMdmFindingRemediationPendingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindingStateTransitionResponse> {
        const response = await this.markMdmFindingRemediationPendingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Apply analyst finding state transition
     */
    async transitionMdmFindingStateRaw(requestParameters: TransitionMdmFindingStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindingStateTransitionResponse>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling transitionMdmFindingState().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling transitionMdmFindingState().'
            );
        }

        if (requestParameters['findingStateTransitionRequest'] == null) {
            throw new runtime.RequiredError(
                'findingStateTransitionRequest',
                'Required parameter "findingStateTransitionRequest" was null or undefined when calling transitionMdmFindingState().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/findings/{instanceId}/state`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindingStateTransitionRequestToJSON(requestParameters['findingStateTransitionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindingStateTransitionResponseFromJSON(jsonValue));
    }

    /**
     * Apply analyst finding state transition
     */
    async transitionMdmFindingState(requestParameters: TransitionMdmFindingStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindingStateTransitionResponse> {
        const response = await this.transitionMdmFindingStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
